import React from 'react';
import { Box } from '@drivekyte/web-components';
import Image from 'next/image';
import styled from 'styled-components';
import WPTypography from '@/components/typography';
import useTranslation from '@/hooks/use-translation';

const AppStoreRating = () => {
  const { t } = useTranslation('components.growth.search');

  return (
    <Box display="flex" alignItems="center" flexDirection="row">
      <Box marginRight="tiny">
        <WPTypography color="primary" fontSize={14} variant="span">
          4.5
        </WPTypography>
      </Box>
      <Image
        src="/images/icons/4-half-stars.svg"
        width={100}
        height={20}
        alt="4.5 star rating"
      />
      <RatingDivier />
      <WPTypography color="quaternary" fontSize={14} variant="span">
        {t('app-store-rating')}
      </WPTypography>
    </Box>
  );
};

const RatingDivier = styled.div`
  background-color: ${({ theme }) => theme.colors.quinary};
  height: 28px;
  width: 1px;
  margin-right: ${({ theme }) => theme.spacings.medium}px;
  margin-left: ${({ theme }) => theme.spacings.medium}px;
`;

export default AppStoreRating;
